export const DEFAULT_STALE_TIME_MS = 1000 * 60 * 60 * 6; // 6 hours in milliseconds
export const DEFAULT_CACHE_TIME_MS = 1000 * 60 * 60 * 24; // 24 hours in milliseconds
